// extracted by mini-css-extract-plugin
export default {"first-to-lower":"_3JMwA5-yQ4","firstToLower":"_3JMwA5-yQ4","first-to-upper":"_1eyskmrN6U","firstToUpper":"_1eyskmrN6U","uppercase":"c1HIkwVA79","lowercase":"_3vFS_3EzCj","capitalize":"_1wc3v2nD4f"};
    if(module.hot) {
      // 1630071360568
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  